import React from 'react';
import { Card, Typography, Button } from 'antd';
import { UserOutlined, LinkOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Paragraph } = Typography;

const NoteLinkPatient = ({ onPatientLinked }) => {
  const { t } = useTranslation();

  const cardTitle = (
    <>
      <UserOutlined style={{ marginRight: 8 }} />
      {t('session_details_patient.link_patient_title')}
    </>
  );

  return (
    <Card
      title={cardTitle}
      style={{ marginBottom: 24 }}
    >
      <Paragraph>{t('session_details_patient.link_patient_subtitle')}</Paragraph>
      <div>
        <Button
          type="default"
          icon={<LinkOutlined />}
          onClick={onPatientLinked}
          data-testid="link-patient-button"
          style={{ width: '250px' }}
        >
          {t('session_details_patient.link')}
        </Button>
      </div>
    </Card>
  );
};

export default NoteLinkPatient; 